import Cash from "react-bootstrap-icons/dist/icons/cash";
import Clock from "react-bootstrap-icons/dist/icons/clock";
import ShieldCheck from "react-bootstrap-icons/dist/icons/shield-check";

export default function Fees() {
  const IconWrap = ({ children }) => (
    <div
      className="rounded-circle border d-flex align-items-center justify-content-center flex-shrink-0"
      style={{ width: 38, height: 38 }}
    >
      {children}
    </div>
  );

  return (
    <section id="fees" className="py-5 bg-brand-orange text-white">
      <div className="main-wrap">
        <div className="row g-4 align-items-start">
          <div className="col-lg-4">
            <h2 className="fw-semibold mb-2">Fees</h2>
            <div className="text-white-50">
              Clear pricing and professional standards
            </div>
          </div>

          <div className="col-lg-8">
            <div className="row g-4">
              <div className="col-md-6">
                <div className="p-4 rounded-4 bg-white bg-opacity-10 border border-white border-opacity-10 h-100">
                  <div className="d-flex gap-3">
                    <IconWrap>
                      <Cash size={20} className="text-brand-orange" />
                    </IconWrap>

                    <div className="w-100">
                      <h3 className="h6 fw-semibold mb-3">Session fees</h3>

                      <p className="text-white-75 mb-4">
                        Fees apply to both assessment and ongoing treatment
                        sessions.
                      </p>

                      <div className="border-top border-white border-opacity-10 pt-3">
                        <div className="d-flex justify-content-between mb-2">
                          <span className="text-white-75">
                            Individual sessions
                          </span>
                          <span className="fw-semibold">£150</span>
                        </div>
                        <div className="d-flex justify-content-between">
                          <span className="text-white-75">Couple sessions</span>
                          <span className="fw-semibold">£170</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="p-4 rounded-4 bg-white bg-opacity-10 border border-white border-opacity-10 h-100">
                  <div className="d-flex gap-3">
                    <IconWrap>
                      <Clock size={20} className="text-brand-orange" />
                    </IconWrap>

                    <div className="w-100">
                      <h3 className="h6 fw-semibold mb-3">
                        Appointments and policy
                      </h3>

                      <div className="text-white-75 mb-3">
                        <div className="mb-2">
                          10:00am to 8:00pm on weekdays
                        </div>
                        <div>48 hours notice required</div>
                      </div>

                      <span className="badge rounded-pill bg-white text-dark">
                        48 hour cancellation policy
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="p-4 rounded-4 bg-white bg-opacity-10 border border-white border-opacity-10">
                  <div className="d-flex gap-3">
                    <IconWrap>
                      <ShieldCheck size={20} className="text-brand-orange" />
                    </IconWrap>

                    <div className="w-100">
                      <h3 className="h6 fw-semibold mb-3">
                        Registration and referrals
                      </h3>

                      <p className="text-white-75 mb-4">
                        We are registered and Chartered Psychologists with the
                        British Psychological Society and the Health and Care
                        Professions Council, ensuring high standards of ethical
                        and professional care.
                      </p>

                      <div className="row g-3">
                        <div className="col-md-6">
                          <div className="p-3 rounded-3 bg-white bg-opacity-10">
                            <div className="fw-semibold mb-1">Referrals</div>
                            <div className="text-white-75">
                              Self-referral, psychiatrists, GPs, insurance
                              providers, and corporations.
                            </div>
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div className="p-3 rounded-3 bg-white bg-opacity-10">
                            <div className="fw-semibold mb-1">Insurers</div>
                            <div className="text-white-75">
                              AXA, BUPA, CIGNA, AVIVA, WPA, Vitality.
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mt-3 text-white-50 small">
                        If you are unsure, contact us and we will guide you.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
